export default __webpack_public_path__ + "static/media/tapicerowane11.fc390905.jpg";